import { render, staticRenderFns } from "./ModalExampleIdentity.vue?vue&type=template&id=fe31934e&scoped=true&"
import script from "./ModalExampleIdentity.vue?vue&type=script&lang=js&"
export * from "./ModalExampleIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe31934e",
  null
  
)

export default component.exports